import { render, staticRenderFns } from "./CDEKShow.vue?vue&type=template&id=45dc4084&scoped=true"
import script from "./CDEKShow.vue?vue&type=script&lang=js"
export * from "./CDEKShow.vue?vue&type=script&lang=js"
import style0 from "./CDEKShow.vue?vue&type=style&index=0&id=45dc4084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc4084",
  null
  
)

export default component.exports